import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ScriptStatus } from 'src/app/interfaces/scriptStatus';
import { URL } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RunScriptService {
  private readonly http = inject(HttpClient);

  /******************************************************
   * Get the list of the status of the script function  *
   *                                                    *
   * @param id - The ID of the status                   *
   * @returns {Observable<ScriptStatus[]>}              *
   ******************************************************/
  getStatusesByScriptId(id: number): Observable<ScriptStatus[]> {
    return this.http.get<ScriptStatus[]>(`${URL.url}${URL.scripts}${id}`);
  }
}
